var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.item.name == 'view')?_c('risk-assessment-view',{attrs:{"isOnboarding":""}}):(_vm.item.name == 'process')?_c('risk-assessment-process',{attrs:{"isOnboarding":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }